import React from 'react'

// The one status chip.
//
// Before this, each module drew its own: ChequeGuard used these Tailwind tones,
// while Estimate / Credit Note / Delivery Challan / Invoice / E-Invoice each had
// a private `statusStyles` map of inline hex colours — and they disagreed with
// each other (a "Closed" credit note was red in one screen and grey in another,
// "Not Invoiced" was coral in one and red in another). One palette now, one
// mapping, so a status means the same colour everywhere.
const TONES = {
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-700',
  amber: 'bg-amber-100 text-amber-700',
  blue: 'bg-blue-100 text-blue-700',
  gray: 'bg-gray-100 text-gray-700',
  teal: 'bg-teal-100 text-teal-700',
  violet: 'bg-violet-100 text-violet-700',
  orange: 'bg-orange-100 text-orange-700',
  lime: 'bg-lime-100 text-lime-700',
}

// Status -> tone for every status label the app renders. Add here, not in a
// screen.
export const STATUS_TONE = {
  // stock / master status
  Active: 'green',
  Inactive: 'red',
  'Low Stock': 'amber',
  Exhausted: 'red',

  // approval
  Approved: 'green',
  Pending: 'amber',
  Rejected: 'orange',
  Cancelled: 'red',

  // document / billing lifecycle
  Draft: 'amber',
  Open: 'blue',
  Sent: 'teal',
  Paid: 'green',
  'Partially Paid': 'blue',
  Invoiced: 'lime',
  'Not Invoiced': 'orange',
  Closed: 'gray',

  // e-invoice
  Generated: 'green',
}

/** Tone for a status label; unknown labels fall back to grey. */
export const statusTone = (label) => STATUS_TONE[label] || 'gray'

const Pill = ({ label, tone, className = '' }) => (
  <span
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
      TONES[tone || statusTone(label)] || TONES.gray
    } ${className}`.trim()}
  >
    {label}
  </span>
)

export default Pill
